// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"warningPopUp__gradient-bg5__cey1_","warning":"warningPopUp__warning__maP2g"};